import React from 'react';
import { Container, Item } from './styles';

const UserImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/user.svg';
const CalendarImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/ScheduleDate.svg';
const PaymentImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/money.svg';
const CameraImg = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Camera.svg';

import { HorizontalLine } from '../../../../../components/HorizontalLine';

import { formatDatetime } from '../../../../../utils/dates';
import ProfessionalCard from '../ProfessionalCard';
import { SlotHour } from '../../../../../modules/slots';

type ScheduleData = {
  slot: SlotHour;
  patientName: string;
  productName: string;
  elegibility: string;
};

export const AppointmentConfirmationCard = ({ patientName, productName, slot, elegibility }: ScheduleData) => {
  return (
    <Container>
      <ProfessionalCard resourceSlot={slot} productName={productName} />

      <HorizontalLine />

      <Item>
        <img src={UserImg} alt="patient" />
        <p>{patientName}</p>
      </Item>

      <Item>
        <img src={CalendarImg} alt="date-and-hour" />
        <p>Consulta Check-up Digital</p>
      </Item>

      <Item>
        <img src={CalendarImg} alt="date-and-hour" />
        <p>{formatDatetime(new Date(`${slot.date}T${slot.hour}`))}</p>
      </Item>

      <Item>
        <img src={PaymentImg} alt="payment-eligibility" />
        <p>{elegibility}</p>
      </Item>

      <Item>
        <img src={CameraImg} alt="telemedicine" />
        <p>Consulta por telemedicina</p>
      </Item>
    </Container>
  );
};
